import flatten from 'lodash/flatten';

const makeFormUrl = (campaignId) =>
    `${process.env.VUE_APP_FORM_URL}/${campaignId}`;

/*
 * function isValidData(requiredKeys, data)
 *
 * requiredKey에 가능한 형태
 * 1: array ex) ['locale', 'token', 'filter']
 * 2: object { key : func } ex) { locale: val => !!val, token: val => !!val }
 * 3: object { key : [ func array ] }  ex) { locale: val => !!val, token: [ a=> a, b => b + 3] }
 *
 * TODO 추가할 사항 => 이게 어떤 파라미터 값이 없는 것인지 알려주는 로직을 추가하면 좋을 것 같음
 */
/**
 * @return {boolean}
 */
function isValidData(requiredKeys, data) {
    return Array.isArray(requiredKeys)
        ? requiredKeys.every((key) => data[key])
        : Object.entries(requiredKeys).every(([key, func]) =>
              Array.isArray(func)
                  ? func.every((fn) => fn(data[key]))
                  : typeof func == 'function'
                  ? func(data[key])
                  : isValidData(func[data[key]], data)
          );
}

const _validate = (val) => val.indexOf('FORM') > -1 || !!val;

const formValidConfig = {
    type: {
        title: {
            title: _validate,
        },
        description: {
            title: R.always(true),
        },
        short: {
            title: _validate,
        },
        checkbox: {
            title: _validate,
        },
        multiple: {
            title: _validate,
        },
        choice: {
            choice: Boolean,
        },
    },
};

const mapIndexed = R.addIndex(R.map);

const checkValidForm = R.pipe(
    R.defaultTo([]),
    mapIndexed((ques, idx) => {
        const mainTypeValue = {
            type: ques.type,
            idx,
            isValid: isValidData(formValidConfig, ques),
        };
        return ques.type == 'checkbox' || ques.type == 'multiple'
            ? [
                  mainTypeValue,
                  ...mapIndexed((choice, subIndex) => {
                      return {
                          type: ques.type,
                          idx,
                          subType: 'choice',
                          subIndex,
                          isValid: isValidData(formValidConfig, choice || []),
                      };
                  }, ques.choices),
              ]
            : mainTypeValue;
    }),
    flatten,
    R.reject(R.prop('isValid'))
);
function changeStoreVal({ keys, keyFlag, index, modifyFn, value }) {
    let _keys = [this.page, keyFlag, index || this.index];
    if (keys) _keys = _keys.concat(keys);
    return this.changeData([
        _keys,
        (state, keys) => {
            const lastParam = R.last(keys),
                obj = R.path(R.init(keys), state);
            if (modifyFn) {
                value
                    ? modifyFn(obj[lastParam], value) //edit
                    : modifyFn(obj, lastParam); //delete
            } else {
                obj[lastParam] = value;
            }
        },
    ]);
}

export { makeFormUrl, checkValidForm, isValidData, changeStoreVal };
